<div class="w-[400px] rounded-md bg-white p-4">
	<h1 class="mb-5 mt-2 font-bold text-on-background"> Un coup de pouce </h1>
	<p class="mb-5 mt-2 font-bold text-on-background-alt"> Je n'ai pas déterminé le sexe du patient </p>
	<button
		class="flex w-full appearance-none items-center justify-between"
		(click)="dialogRef.close(Sexe.FEMME)"
	>
		<span class="p-2 font-display text-sm font-bold"> C'est une femme </span>
		<div class="uikit-btn uikit-btn-tonal uikit-btn-round-default uikit-fab-small flex">
			<uikit-icon
				name="angle-right-b"
				size="small"
				fill="on-tonal"
			/>
		</div>
	</button>
	<uikit-divider type="default" />
	<button
		class="flex w-full appearance-none items-center justify-between"
		(click)="dialogRef.close(Sexe.HOMME)"
	>
		<span class="p-2 font-display text-sm font-bold"> C'est un homme </span>
		<div class="uikit-btn uikit-btn-tonal uikit-btn-round-default uikit-fab-small flex">
			<uikit-icon
				name="angle-right-b"
				size="small"
				fill="on-tonal"
			/>
		</div>
	</button>
	<uikit-divider type="default" />
	<button
		class="flex w-full appearance-none items-center justify-between"
		(click)="dialogRef.close(null)"
	>
		<span class="p-2 font-display text-sm font-bold"> Non renseigné </span>
		<div class="uikit-btn uikit-btn-tonal uikit-btn-round-default uikit-fab-small flex">
			<uikit-icon
				name="angle-right-b"
				size="small"
				fill="on-tonal"
			/>
		</div>
	</button>
</div>
<uikit-button
	color="tonal"
	size="large"
	radius="full"
	icon="times"
	class="fixed right-7.5 top-7.5"
	(action)="dialogRef.close()"
/>
